import { useCallback, useEffect, useState } from "react";

export const PERSIST_SIDEBAR = "persist:sidebar";

const getSidebarStateFromStorage = (): boolean => {
  const state = sessionStorage.getItem(PERSIST_SIDEBAR) ?? "true";
  return JSON.parse(state);
};
const setSidebarStateToStorage = (value: boolean) => sessionStorage.setItem(PERSIST_SIDEBAR, JSON.stringify(value));

export const useSidebarOpen = () => {
  const [sidebarOpen, setSidebarOpen] = useState(getSidebarStateFromStorage);

  const toggleSidebarOpen = useCallback(() => {
    setSidebarStateToStorage(!sidebarOpen);
    setSidebarOpen(!sidebarOpen);
  }, [sidebarOpen]);

  useEffect(() => {
    window.addEventListener("beforeunload", () => setSidebarStateToStorage(sidebarOpen));
    return () => {
      window.addEventListener("beforeunload", () => setSidebarStateToStorage(sidebarOpen));
    };
  }, [sidebarOpen]);

  return {
    sidebarOpen,
    toggleSidebarOpen,
  };
};
